export const mapUrlToStrapi = (url: string) => {
  return url;
  // if (!url) {
  //   return '/other/img-placeholder.jpeg';
  // }
  // return `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`;
};
